React = require 'react'
t = require('views/internal/recup-with-helpers')('')

class PopOverListComponent extends React.Component
  render: t.renderable ->
    { items } = @props

    t.ul '.pop-over-list', ->
      items.forEach (item) ->
        t.li onClick: item.onClick, ->
          t.addElement item.content

module.exports = PopOverListComponent



// WEBPACK FOOTER //
// ./app/scripts/views/internal/pop-over-list-component.coffee